module.exports = __webpack_public_path__ + "static/business-types-bg-4a0ecaae79abe73cec70a1071f9365d5.png";